import { createNamedApi } from '@essent/common';

import { GetOfferService } from './get-offer.service';

export const getOfferApi = createNamedApi(
  '[become-a-customer] Get Offer',
  GetOfferService
);
